import React from 'react';
import styled, { keyframes } from 'styled-components';
// Keyframe for the pulse animation
const pulse = keyframes`
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
`;

// Styled container
const Container = styled.div`
  width: 100%;
  height: 100%;
  padding: 1rem;
  animation: ${pulse} 2s infinite;
`;

// Common styles for the loading bars
const LoadingBar = styled.div<{ $width?: string }>`
  height: 1rem; /* h-4 */
  margin: 0.5rem 0; /* my-2 */
  background-color: #e5e7eb; /* bg-gray-200 */
  border-radius: 9999px; /* rounded-full */
  width: ${(props) => props.$width || '100%'};

  .dark & {
    background-color: #3f3f46; /* dark:bg-neutral-700 */
  }
`;

export const Skeleton = () => {
  return (
    <Container>
      <LoadingBar $width="30%" />
      <LoadingBar />
      <LoadingBar />
      <LoadingBar $width="90%" />
      <LoadingBar />
      <LoadingBar $width="95%" />
      <LoadingBar />
      <LoadingBar $width="85%" />
    </Container>
  );
};
